<template>
  <active-section section-name="about">
    <div class="content about">
      <!-- title -->
      <div class="title">About Me</div>

      <!-- content -->
      <div class="row">
        <div class="col col-d-6 col-t-6 col-m-12 border-line-v">
          <div class="text-box">
            <p>
              My name is mond , I'm experienced in programmer position 5 years, So it not enough for career path in programmer, I always learning for new technology for improve programming skill.
            </p>
            <p>
              When i typed a keyboard for development some application feeling like i playing sudoku, I had to go through trial and error to find the best results and solved it
            </p>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <!--
      Services
    -->
    <div class="content services">
      <!-- title -->
      <div class="title">My Skill</div>

      <!-- content -->
      <div class="row service-items border-line-v">
        <!-- service item -->
        <div class="col col-d-6 col-t-6 col-m-12 border-line-h">
          <div class="service-item">
            <div class="icon">
              <span class="fa fa-code"></span>
            </div>
            <div class="name">
              <span>Programming</span>
            </div>
            <div class="desc">
              <div>
                <ul class="text-orange">
                  <li>VueJS</li>
                  <li>NestJS</li>
                  <li>ReactJS</li>
                  <li>PHP</li>
                  <li>Python</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- service item -->
        <div class="col col-d-6 col-t-6 col-m-12 border-line-h">
          <div class="service-item">
            <div class="icon">
              <span class="fa fa-cogs"></span>
            </div>
            <div class="name">
              <span> DevOPS </span>
            </div>
            <div class="desc">
              <div>
                <ul class="text-orange">
                  <li>Docker / K8s</li>
                  <li>RMQ</li>
                  <li>AWS</li>
                  <li>Jenkins</li>
                  <li>Gitlab CI/CD</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-d-6 col-t-6 col-m-12 border-line-h">
          <div class="service-item">
            <div class="icon">
              <span class="fa fa-database"></span>
            </div>
            <div class="name">
              <span> Database </span>
            </div>
            <div class="desc">
              <div>
                <ul class="text-orange">
                  <li>PostgreSQL</li>
                  <li>MongoDB</li>
                  <li>MySQL</li>
                  <li>MSSQL</li>
                  <li>Redis</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- service item -->
        <div class="col col-d-6 col-t-6 col-m-12 border-line-h">
          <div class="service-item">
            <div class="icon">
              <span class="fa fa-legal"></span>
            </div>
            <div class="name">
              <span> Management </span>
            </div>
            <div class="desc">
              <div>
                <ul class="text-orange">
                  <li>Agile / Scrum</li>
                  <li>Click Up</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </active-section>
</template>

<script>
import ActiveSection from "@/components/activeSection";

export default {
  name: "about",
  components: {
    ActiveSection
  }
};
</script>

<style scoped>
.text-orange {
  color: orange;
}
</style>
